"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _rcSlider = _interopRequireDefault(require("rc-slider"));

var _lodash = require("lodash");

var _Icon = _interopRequireDefault(require("./Icon"));

var _KeyboardShortcutIndicator = _interopRequireDefault(require("./KeyboardShortcutIndicator"));

var SliderControl = function SliderControl(_ref) {
  var className = _ref.className,
      label = _ref.label,
      onChange = _ref.onChange,
      reverse = _ref.reverse,
      shortcutDown = _ref.shortcutDown,
      shortcutUp = _ref.shortcutUp,
      showValue = _ref.showValue,
      style = _ref.style,
      value = _ref.value,
      valueDefault = _ref.valueDefault,
      valueMax = _ref.valueMax,
      valueMin = _ref.valueMin,
      valueStep = _ref.valueStep;
  return _react.default.createElement("section", {
    className: className,
    style: style
  }, (label || showValue) && _react.default.createElement("div", null, label && _react.default.createElement("span", null, label, ": "), showValue && _react.default.createElement("strong", null, value)), _react.default.createElement(_rcSlider.default, {
    className: "margin-bottom-1",
    defaultValue: valueDefault,
    max: valueMax,
    min: valueMin,
    onChange: onChange,
    step: valueStep,
    value: value
  }), (shortcutDown || shortcutUp) && _react.default.createElement("div", {
    className: "flex-row",
    style: {
      justifyContent: 'space-between'
    }
  }, shortcutDown && shortcutDown.shortcut && _react.default.createElement("div", null, _react.default.createElement(_KeyboardShortcutIndicator.default, {
    label: shortcutDown.label && shortcutDown.label,
    reverse: reverse,
    shortcut: shortcutDown.shortcut,
    tooltip: shortcutDown.tooltip && shortcutDown.tooltip,
    onClick: function onClick() {
      return onChange((0, _lodash.clamp)(value - valueStep, valueMin, valueMax));
    }
  })), shortcutUp && shortcutUp.shortcut && _react.default.createElement("div", null, _react.default.createElement(_KeyboardShortcutIndicator.default, {
    label: shortcutUp.label && shortcutUp.label,
    reverse: reverse,
    shortcut: shortcutUp.shortcut,
    tooltip: shortcutUp.tooltip && shortcutUp.tooltip,
    onClick: function onClick() {
      return onChange((0, _lodash.clamp)(value + valueStep, valueMin, valueMax));
    }
  }))));
};

SliderControl.defaultProps = {
  keyboardShortcuts: [],
  label: null,
  onChange: function onChange() {
    return null;
  },
  reverse: false,
  shortcutDown: null,
  shortcutUp: null,
  showValue: false,
  value: 5,
  valueDefault: 5,
  valueMax: 10,
  valueMin: 1,
  valueStep: 1
};
var _default = SliderControl;
exports.default = _default;